import { render, staticRenderFns } from "./recreate-signature-modal.vue?vue&type=template&id=0a1c0e3c&"
import script from "./recreate-signature-modal.vue?vue&type=script&lang=ts&"
export * from "./recreate-signature-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports